// Club Events Service - API calls for club event management

import { apiClient } from './apiClient';
import { ClubEventItem, CreateClubEventRequest, EventRsvpItem } from '../types/clubEvents.types';

class ClubEventsService {
  async getEvents(scopeType?: string, scopeDepartmentId?: string, futureOnly: boolean = true): Promise<ClubEventItem[]> {
    const params: Record<string, string> = { futureOnly: String(futureOnly) };
    if (scopeType) params.scopeType = scopeType;
    if (scopeDepartmentId) params.scopeDepartmentId = scopeDepartmentId;
    const response = await apiClient.get('/club/events', { params });
    return response.data;
  }

  async getEvent(id: string): Promise<ClubEventItem> {
    const response = await apiClient.get(`/club/events/${id}`);
    return response.data;
  }

  async createEvent(data: CreateClubEventRequest): Promise<ClubEventItem> {
    const response = await apiClient.post('/club/events', data);
    return response.data;
  }

  async updateEvent(id: string, data: CreateClubEventRequest): Promise<ClubEventItem> {
    const response = await apiClient.put(`/club/events/${id}`, data);
    return response.data;
  }

  async deleteEvent(id: string): Promise<void> {
    await apiClient.delete(`/club/events/${id}`);
  }

  async getRsvps(id: string): Promise<EventRsvpItem[]> {
    const response = await apiClient.get(`/club/events/${id}/rsvps`);
    return response.data;
  }
}

export const clubEventsService = new ClubEventsService();
